import Dialog from '@/components/Dialog';
import { CircularProgress } from '@mui/material';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';

const LoadingStateWrapper = styled('div')(({ theme }) => ({
  marginTop: -20,
  padding: 24,
  height: 300,
  backgroundColor: theme.palette.action.selected,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 4,
  p: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 12,
    color: theme.palette.text.secondary,
  },
}));

const TagsLoadingState = () => (
  <Dialog.Content>
    <LoadingStateWrapper>
      <CircularProgress size={18} color="secondary" />
      <p>
        <FormattedMessage id="editor.model_editor.field_editor.tags_editor.dialog.tags_manager.loading_state" />
      </p>
    </LoadingStateWrapper>
  </Dialog.Content>
);

export default TagsLoadingState;
